import { setAlert } from '../alert';
import {
    SET_CONFIRM_MESSAGE,
    REMOVE_CONFIRM_MESSAGE,
    SET_IS_CONFIRM,
    SET_CONFIRM_FIELD,
    REMOVE_CONFIRM_FIELD
} from '../../types';

export const setConfirmMessage = (message) => async(dispatch) => {
    try {
        dispatch({
            type: SET_CONFIRM_MESSAGE,
            payload: message
        });
    }
    catch (error) {
        dispatch(setAlert(error.message, 'error'));
    }
};

export const setIsConfirm = (isConfirm) => async(dispatch) => {
    try {
        await dispatch({
            type: SET_IS_CONFIRM,
            payload: isConfirm
        });
        if (!isConfirm) {
            dispatch(removeConfirmMessage());
            dispatch(removeConfirmField());
        }
    }
    catch (error) {
        dispatch(setAlert(error.message, 'error'));
    }
};

export const setConfirmField = (field) => async(dispatch) => {
    try {
        dispatch({
            type: SET_CONFIRM_FIELD,
            payload: field
        });
    }
    catch (error) {
        dispatch(setAlert(error.message, 'error'));
    }
};
export const removeConfirmField = () => async(dispatch) => {
    try {
        dispatch({ type: REMOVE_CONFIRM_FIELD });
    }
    catch (error) {
        dispatch(setAlert(error.message, 'error'));
    }
};

export const removeConfirmMessage = () => async(dispatch) => {
    try {
        dispatch({ type: REMOVE_CONFIRM_MESSAGE });
    }
    catch (error) {
        dispatch(setAlert(error.message, 'error'));
    }
};

export const triggerConfirmModal = (message, field) => async(dispatch) => {
    try {
        const button = document.getElementById('confirmModalButton');
        button.click();
        await dispatch(setConfirmMessage(message));
        await dispatch(setConfirmField(field));
    }
    catch (error) {
        dispatch(setAlert(error.message, 'error'));
    }
};